import { parentWindowMessageStream, sendCommandToParentWindow } from "./parentWindowConnection";
import { filter, map, first } from "rxjs/operators";
import log2 from "./log2";
import { sendSocketMessage, socketMessageStream } from "./socketStream";
import store from "../store";

const Commands = {
    AKINON_GET_ORDERS: "akinon-get-orders",
    AKINON_GET_USER_DATA: "akinon-get-user-data",
};
const log = log2("AkinonScrapperApiClient");
let singletonInstance = null;

export default class AkinonScrapperApiClient {
    constructor() {
        this.listenSocketMessages();
        this.akinonUserData = null;
        this.listenWindow();
        // this.getUserData();
    }

    static create() {
        if (singletonInstance) {
            return singletonInstance;
        } else {
            singletonInstance = new AkinonScrapperApiClient();
            return singletonInstance;
        }
    }

    listenWindow() {
        parentWindowMessageStream
            .pipe(
                filter((q) => q.command === "akinon-set-user-data"),
                map((x) => x.payload)
            )
            .subscribe((payload) => {
                this.setUserData(payload);
            });
    }

    getOrders(siteId, visitorId, conversationId, instanceId) {
        log.info("getOrders", { siteId, visitorId, conversationId, instanceId });
        parentWindowMessageStream
            .pipe(
                filter((q) => q.command === "akinon-get-orders"),
                map((x) => x.payload),
                first()
            )
            .toPromise()
            .then((payload) => {
                sendSocketMessage("akinon get-orders-response", {
                    visitorId,
                    conversationId,
                    instanceId,
                    siteId,
                    orders: payload.orders,
                });
            });

        sendCommandToParentWindow(Commands.AKINON_GET_ORDERS, {});
    }

    getUserData() {
        log.info("getUserData", {});
        if (this.akinonUserData) {
            return Promise.resolve(this.akinonUserData);
        }
        const realPromise = parentWindowMessageStream
            .pipe(
                filter((q) => q.command === Commands.AKINON_GET_USER_DATA),
                map((x) => x.payload),
                first()
            )
            .toPromise()
            .then((data) => {
                this.akinonUserData = data;
                return data;
            })
            .catch((err) => {
                log.error("getUserData error", { err });
                return undefined;
            });

        const timeoutPromise = new Promise((resolve) => {
            setTimeout(() => {
                resolve(undefined);
            }, 5000);
        });
        sendCommandToParentWindow(Commands.AKINON_GET_USER_DATA, {});

        return Promise.race([realPromise, timeoutPromise]);
    }

    setUserData(data) {
        this.akinonUserData = data;
    }

    listenSocketMessages() {
        log.info("listenSocketMessages");
        socketMessageStream.pipe(filter(({ cmd, data }) => cmd.startsWith("akinon"))).subscribe(({ cmd, data }) => {
            if (cmd === "akinon get_orders") {
                const { siteId, visitorId, conversationId, instanceId } = data;
                this.getOrders(siteId, visitorId, conversationId, instanceId);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/utils/AkinonScrapperApiClient.js